import React, {useImperativeHandle, useRef} from 'react'
import WizModal from '../../../components/modal/WizModal'
import useQueryGetUsedMyRefCode from '../../../hooks/api/user/useQueryGetUsedMyRefCode'
import useNavigation from '../../../hooks/useNavigation'
import WizImage from '../../../components/image/WizImage'
import {useImage} from '../../../utils/image'
import Text from '../../../components/text/Text'

interface IProps {
    className?: string
    userId: string
}

const UsedMyReferralCodeList = ({className, userId}: IProps, ref: any) => {
    const modalRef = useRef<any>()
    const {data} = useQueryGetUsedMyRefCode(userId)
    const {goUserDetail} = useNavigation()
    const {renderThumbnail} = useImage()

    useImperativeHandle(ref, () => ({
        show: () => {
            modalRef.current.show()
        },
    }))

    return (
        <>
            <WizModal title={'Used My Referral Code'} className={`max-w-[400px] ${className}`} ref={modalRef}>
                <div className={'max-h-[500px] overflow-y-auto'}>
                    {data?.map(item => (
                        <div
                            onClick={() => {
                                goUserDetail(item?.id)
                                modalRef?.current?.close()
                            }}
                            key={item?.id}
                            className={
                                'flex items-center gap-x-[5px] cursor-pointer p-[10px] hover:bg-bg_gray01 border-b border-line03 last:border-none'
                            }>
                            <WizImage
                                src={renderThumbnail(item?.thumbnail)}
                                className={'w-[40px] h-[40px] rounded-full'}
                            />
                            <div>
                                <Text>{item?.name}</Text>
                                <Text className={'text-font03 text-body_comm'}>({item?.id})</Text>
                            </div>
                        </div>
                    ))}
                </div>
            </WizModal>
        </>
    )
}

export default React.forwardRef(UsedMyReferralCodeList)
